import jsBridge from './index'
/**
 * 判断浏览器环境
 */
export default function takeCamera() {
  return jsBridge('takeCamera')
}
